import {Text} from "@crunchyroll/cx-web-components";
import {FormattedMessage} from "react-intl";

import styles from "./FooterTextItem.module.scss";

const ICON_POSITION = {
  start: "start",
  end: "end",
};

const FooterTextItem = ({
  icon: Icon,
  messageId,
  iconPosition = ICON_POSITION.start,
  iconClassName = "",
}) => {
  const hasStartIcon = Icon && iconPosition === ICON_POSITION.start;
  const hasEndIcon = Icon && iconPosition === ICON_POSITION.end;

  return (
    <li className={styles.item}>
      <Text className={`${styles.text}`} as="span" size="m">
        {hasStartIcon && (
          <Icon
            className={`${styles.icon} ${styles.startIcon} ${iconClassName}`}
          />
        )}
        <FormattedMessage id={messageId} />
        {hasEndIcon && (
          <Icon
            className={`${styles.icon} ${styles.endIcon} ${iconClassName}`}
          />
        )}
      </Text>
    </li>
  );
};

export default FooterTextItem;
